import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import Tooltip from '@/design_system/Tooltip';
import InlineText from '@/design_system/Typography/InlineText';
import IconRefusal from '@/icons/Refusal.svg';
import useViewPort from '@/utils/useViewport';

export const DefectNotUnderBrandResponsibility = () => {
  const { isMobile } = useViewPort();

  if (isMobile) {
    return (
      <Tooltip
        content={
          <Trans id="client.article.services.column.defect.defect-not-under-brand-responsibility">
            Defect not under brand responsibility
          </Trans>
        }
      >
        <Button variant="style-less">
          <IconRefusal className="text-danger" style={{ fontSize: '1rem' }} />
        </Button>
      </Tooltip>
    );
  }

  return (
    <Stack row alignItems="center" gap="0.25rem">
      <IconRefusal className="text-danger" />
      <InlineText color="secondary" size="200">
        <Trans id="client.article.services.column.defect.not-under-brand-responsibility">
          Not under brand responsibility
        </Trans>
      </InlineText>
    </Stack>
  );
};
